import { useState } from 'react';

export interface IPagination {
    page: number;
    rows: number;
    totalCount: number;
    totalPages?: number;
}

/**Custom hook for handling pagination
 * @param page: number
 * @param rows: number
 */
const usePagination = (page?: number, rows?: number) => {
    const [pagination, setPagination] = useState<IPagination>({
        page: page || 1,
        rows: rows || 8,
        totalCount: 0,
        totalPages: 0,
    });

    const handleRowsChange = (rows: number) => {
        setPagination((prevPag: any) => ({
            ...prevPag,
            rows,
        }));
    };

    const handlePageChange = (page: number) => {
        setPagination((prevPag: any) => ({
            ...prevPag,
            page,
        }));
    };

    return { pagination, setPagination, handleRowsChange, handlePageChange };
};

export { usePagination };
